<script setup lang="ts">
import TextBlockEn from "@/views/main/EthicalCodeView/textBlockEn.vue"
import TextBlockIt from "@/views/main/EthicalCodeView/textBlockIt.vue"

const selectedLanguage = I18n.locale
</script>

<template>
  <div class="container">
    <h2 class="title">{{ $t("ethical_code.title") }}</h2>

    <text-block-en v-if="selectedLanguage === 'en'" />

    <text-block-it v-else />
  </div>
</template>
